import React from 'react';

export const InformativaSection = ({ value, onChange }) => (
  <div className="form-section pl-8">
    <div className="flex items-center gap-4">
      <span className="text-sm text-[#A1A1AA]">Inviata informativa all'Autorità Giudiziaria</span>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="radio" checked={!value} onChange={() => onChange(false)} className="accent-[#E3000F]" />
          <span className="text-white">NO</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="radio" checked={value} onChange={() => onChange(true)} className="accent-[#E3000F]" />
          <span className="text-white">SI</span>
        </label>
      </div>
    </div>
  </div>
);
